export const AdminDashboardIcon = ({ size = 18, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6.31558 12.5295H11.1614"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.75 10.5108C0.75 5.81833 1.26167 6.14583 4.01583 3.59167C5.22083 2.62167 7.09583 0.75 8.715 0.75C10.3333 0.75 12.2458 2.6125 13.4617 3.59167C16.2158 6.14583 16.7267 5.81833 16.7267 10.5108C16.7267 17.4167 15.0942 17.4167 8.73833 17.4167C2.3825 17.4167 0.75 17.4167 0.75 10.5108Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
